(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/directives/scPaymentTypes/template', '<div class="payment-types">\n' + '  <div\n' + '    class="payment-types_card"\n' + '    ng-class="cardClass(card)"\n' + '    ng-repeat="card in scPaymentTypes"\n' + '    title="{{ card }}"\n' + '  ></div>\n' + '\n' + '  <div class="payment-types_card paypal" data-ng-if="paypal()">\n' + '    <div class="payment-types_paypal-submit" data-ng-click="paypalSubmit()"></div>\n' + '  </div>\n' + '</div>\n' + '');
}]);
})();